import { render, staticRenderFns } from "./RecreationalOrderTypePopUp.vue?vue&type=template&id=2158a3db&scoped=true&"
import script from "./RecreationalOrderTypePopUp.vue?vue&type=script&lang=js&"
export * from "./RecreationalOrderTypePopUp.vue?vue&type=script&lang=js&"
import style0 from "./RecreationalOrderTypePopUp.vue?vue&type=style&index=0&id=2158a3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158a3db",
  null
  
)

export default component.exports